import type {LoaderFunctionArgs} from 'react-router'
import {useLoaderData} from 'react-router-dom'

import {getNavigationState} from '../../helpers/navigationStateCache.ts'
import {withThirdPartiesParam} from '../../hocs/withThirdPartiesParam.js'
import {getInitialProps} from './getInitialProps'
import MakesDistributorComponentRaw from './index.js'

// Import styles
import './styles/index.scss'
// HOC wrapping that used to live in `./index.js`. Moved here so `./index.js`
// exports the raw component and receives Fast Refresh in dev.
const MakesDistributorComponent = withThirdPartiesParam(MakesDistributorComponentRaw)

export async function loader({context, request, params}: LoaderFunctionArgs) {
  const url = new URL(request.url)
  const pathname = url.pathname
  const query = Object.fromEntries(url.searchParams.entries())

  // Build routeInfo compatible with getInitialProps
  const routeInfo = {
    location: {
      pathname,
      query,
      search: url.search,
      state: getNavigationState(pathname)
    },
    params
  }

  // Call existing getInitialProps
  const data = await getInitialProps({routeInfo, context})

  return data
}

export function Component() {
  const data = useLoaderData()
  return <MakesDistributorComponent {...data} />
}
